exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-toggle=\"toggle\"] {\n  display: none; }\n\n.testcss {\n  display: none;\n  visibility: hidden; }\n\n.col-2-print {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 10%;\n  flex: 0 0 10%;\n  max-width: 10%;\n  margin-left: 1rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/ae-summary-visit-summary-by-team/ae-summary-visit-summary-by-team.component.scss
// module id = ../../../../../src/app/crm/ae-summary-visit-summary-by-team/ae-summary-visit-summary-by-team.component.scss
// module chunks = main